import { render } from "./ModelSelect.vue?vue&type=template&id=72f00706&scoped=true"
import script from "./ModelSelect.vue?vue&type=script&lang=js"
export * from "./ModelSelect.vue?vue&type=script&lang=js"

import "./ModelSelect.vue?vue&type=style&index=0&id=72f00706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f00706"]])

export default __exports__